import { ReactNode, useEffect, useState } from 'react';
import Alert from '../alert/alert';

export interface AlertProps {
  message?: string;
}

export const useAlert = (options: {
  title?: string;
  message: ReactNode;
  type: 'success' | 'error' | 'warning' | 'info';
  showDismissButton?: boolean;
  makeBlocking?: boolean;
}) => {
  const [timeoutDuration, setTimeoutDuration] = useState<number>(-1);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [timeoutId, setTimeoutId] = useState<ReturnType<
    typeof setTimeout
  > | null>(null);
  const [defaultMessage, setDefaultMessage] = useState<ReactNode>(
    options.message
  );

  const onClickDismissAlert = () => {
    setShowAlert(false);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  };

  useEffect(() => {
    if (timeoutDuration !== -1) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setTimeoutDuration(-1);
        setShowAlert(false);
      }, timeoutDuration);

      setTimeoutId(timeoutId);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutDuration]);

  return {
    Alert: ({ message }: AlertProps) => {
      return (
        <Alert
          makeBlocking={options.makeBlocking}
          showDismissButton={
            options.showDismissButton ||
            timeoutDuration === -1 ||
            timeoutDuration > 10000
          }
          showAlert={showAlert}
          dismissAlert={onClickDismissAlert}
          title={options.title}
          message={message || defaultMessage}
          type={options.type}
        />
      );
    },
    fireAlert: (timeoutDuration: number) => {
      setTimeoutDuration(timeoutDuration);
    },
    setAlertMessage: (message: ReactNode) => {
      setDefaultMessage(message);
    },
  };
};
